import React, { useEffect, useState } from "react";
import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import styles from "./input.module.css";

const DropDownInput = (props) => {
	const {
		quizOptions,
		question,
		field,
		hasError,
		errorMessage,
		onLogicChange,
		hasOthersError,
		onOtherTextChange,
		hideOthers,
		index,
	} = props;

	const [showInput, setShowInput] = useState(false);
	const [otherText, setOtherText] = useState("");
	const [error, setError] = useState({
		show: false,
		message: "",
	});

	const properOptions = quizOptions.map((option) => {
		const optionId = option?.option_id
			? option.option_id
			: quizOptions[1].option_id - 1;

		return {
			...option,
			option_id: optionId,
		};
	});

	const isAboveOption = properOptions.find((option) =>
		option?.option_text.toLowerCase().includes("above n")
	);
	const isOptionOthers = properOptions.find((option) =>
		option?.option_text.toLowerCase().includes("specify")
	);

	const handleChange = (e) => {
		const selectedOption = properOptions.find(
			(option) => option.option_id.toString() === e.target.value
		);

		//REMOVE action indicates removing the next_question_id from the list of originally hidden quizzes
		if (selectedOption && selectedOption.next_question_id) {
			onLogicChange({
				action: "REMOVE",
				currentId: selectedOption?.quiz_id,
				targetedId: selectedOption.next_question_id,
			});
		} else {
			properOptions.forEach((option) => {
				if (
					option.next_question_id !== null &&
					option.next_question_id !== selectedOption.next_question_id
				) {
					//ADD action indicates adding the next_question_id back to the list of originally hidden quizzes, for a quiz that is not selected
					onLogicChange({
						action: "ADD",
						currentId: selectedOption?.quiz_id,
						targetedId: option.next_question_id,
					});
				}
			});
		}

		if (
			selectedOption &&
			(selectedOption?.option_text.toLowerCase().includes("above n") ||
				selectedOption?.option_text.toLowerCase().includes("specify"))
		) {
			setShowInput(true);
		} else {
			setShowInput(false);
		}

		field?.onChange(e);
	};

	useEffect(() => {
		if (showInput && otherText.trim() === "") {
			setError({
				show: true,
				message: "value is required",
			});
			hasOthersError(true);
		} else {
			setError({
				show: false,
				message: "",
			});
			hasOthersError(false);
		}

		if (!showInput) {
			hasOthersError(false);
			onOtherTextChange({
				id: Number(field?.name),
				text: "NULL",
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showInput, otherText]);

	return (
		<div
			className={styles.dropdown_wrapper}
			data-testid="dropdown_input_container"
		>
			<div className="flex mb-1 gap-2">
				<span className="text-center bg-primary text-white py-[2px] px-1 rounded-sm !text-sm mr-2 block h-6">
					{index + 1}
				</span>
				<p>{question}</p>
			</div>
			<FormControl fullWidth>
				<InputLabel id="quiz_9_label">Choose one</InputLabel>
				<Select
					{...field}
					value={field.value ?? ""}
					labelId="quiz_9_label"
					variant="filled"
					size="small"
					onChange={handleChange}
					data-testid="dropdown_select_field"
				>
					{properOptions.map((option) => (
						<MenuItem
							key={option.option_id}
							value={option.option_id.toString()}
							data-testid="dropdown_menu_item"
						>
							{option.option_text}
						</MenuItem>
					))}
				</Select>
				{hasError && (
					<small
						className="text-danger mt-2"
						data-testid="dropdown_error_element"
					>
						{errorMessage}
					</small>
				)}
			</FormControl>

			{!hideOthers &&
				isAboveOption &&
				(isAboveOption?.option_id.toString() === field?.value ||
					showInput) && (
					<div
						className="w-full mb-3"
						data-testid="dropdown_text_input_container"
					>
						<TextField
							id="otherText"
							label="enter cost here"
							variant="outlined"
							size="small"
							className="w-full"
							onChange={(e) => {
								setOtherText(e.target.value);
								onOtherTextChange({
									id: Number(field?.name),
									text: e.target.value,
								});
							}}
							data-testid="dropdown_text_input"
						/>
						{error.show && (
							<small
								className="text-danger mt-2"
								data-testid="dropdown_text_input_error_element"
							>
								{error.message}
							</small>
						)}
					</div>
				)}
			{isOptionOthers &&
				(isOptionOthers?.option_id.toString() === field?.value ||
					showInput) && (
					<div
						className="w-full mb-3"
						data-testid="dropdown_text_input_container"
					>
						<TextField
							id="otherText"
							label="enter other value here"
							variant="outlined"
							size="small"
							className="w-full"
							onChange={(e) => {
								setOtherText(e.target.value);
								onOtherTextChange({
									id: Number(field?.name),
									text: e.target.value,
								});
							}}
							data-testid="dropdown_text_input"
						/>
						{error.show && (
							<small
								className="text-danger mt-2"
								data-testid="dropdown_text_input_error_element"
							>
								{error.message}
							</small>
						)}
					</div>
				)}
		</div>
	);
};

export default DropDownInput;
